import { axiosInstance, axiosUserAppInstance } from "./";

const getEventsList = async (params) =>
  await axiosInstance.get("/events", { params });

/** User-app events list (e.g. supervisor login with `supervisor_id`). */
const getUserAppEventsList = async (params) =>
  await axiosUserAppInstance.get("/events", { params });

const addEvent = async ({ data }) => await axiosInstance.post(`/events`, data);

const getEvent = async (id) => await axiosInstance.get(`/events/${id}`);

const getUserAppEvent = async (id) =>
  await axiosUserAppInstance.get(`/events/${id}`);

const editEvent = async ({ data, id }) =>
  await axiosInstance.patch(`/events/${id}`, data);

const publishEvent = async (id) =>
  await axiosInstance.post(`/events/${id}/publish`);

const deleteEvent = async (id) => await axiosInstance.delete(`/events/${id}`);

const cancelEvent = async (id) =>
  await axiosInstance.post(`/events/${id}/cancel`);

const inviteApplicants = async (data) =>
  await axiosInstance.post(`/event_invitations`, data);

const checkEventConflicts = async ({ id, params }) =>
  await axiosInstance.get(`/events/${id}/conflicting_resources`, { params });

const sendPushNotification = async ({ id, params }) =>
  await axiosInstance.post(`/events/${id}/send_push_notifications`, params);

/** PROLINE-3179 — event-level automatic-deduction flags. */
const updateEventAutoDeduction = async ({ id, params }) =>
  await axiosInstance.patch(`/events/${id}/update_auto_deduction`, params);

/** PROLINE-3796 — `calculate_by_checkin_only` ("Pay Full Scheduled Shift"). */
const updateEventCalculationSettings = async ({ id, params }) =>
  await axiosInstance.patch(`/events/${id}/update_calculation_settings`, params);

const addBulkRewardToggle = async ({ id, params }) =>
  await axiosInstance.post(
    `/events/${+id}/add_reward_to_event_organizers`,
    params
  );

const getPayrollPerDay = async ({ id }) =>
  await axiosInstance.get(`/events/${+id}/payroll_amount_per_day`);

export {
  getEventsList,
  getUserAppEventsList,
  getEvent,
  getUserAppEvent,
  addEvent,
  editEvent,
  publishEvent,
  deleteEvent,
  cancelEvent,
  inviteApplicants,
  checkEventConflicts,
  sendPushNotification,
  updateEventAutoDeduction,
  updateEventCalculationSettings,
  addBulkRewardToggle,
  getPayrollPerDay,
};
